import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Processos from './pages/Processos'
import NovoProcesso from './pages/NovoProcesso'
import DetalheProcesso from './pages/DetalheProcesso'
import CartaoProtocolo from './pages/CartaoProtocolo'
import Consulta from './pages/Consulta'
import Secretarias from './pages/Secretarias'
import Tipos from './pages/Tipos'
import Usuarios from './pages/Usuarios'
import Perfis from './pages/Perfis'
import Cidadaos from './pages/Cidadaos'
import Portal from './pages/Portal'
import PortalServidor from './pages/PortalServidor'
import Configuracoes from './pages/Configuracoes'
import Modelos from './pages/Modelos'
import Auditoria from './pages/Auditoria'
import ContribuintePresencial from './pages/ContribuintePresencial'
import Aprovacoes from './pages/Aprovacoes'
import SuperAdmin from './pages/superadmin/SuperAdmin'
import MeuPerfil from './pages/MeuPerfil'
import ProtocoloPublico from './pages/ProtocoloPublico'

function Protegida({ children }) {
  return localStorage.getItem('pg_token') ? children : <Navigate to="/login" replace />
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/consulta" element={<Consulta />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/servidor" element={<PortalServidor />} />
        <Route path="/superadmin" element={<SuperAdmin />} />
        <Route path="/dashboard" element={<Protegida><Dashboard /></Protegida>} />
        <Route path="/processos" element={<Protegida><Processos /></Protegida>} />
        <Route path="/processos/novo" element={<Protegida><NovoProcesso /></Protegida>} />
        <Route path="/processos/:id" element={<Protegida><DetalheProcesso /></Protegida>} />
        <Route path="/processos/:id/cartao" element={<Protegida><CartaoProtocolo /></Protegida>} />
        <Route path="/secretarias" element={<Protegida><Secretarias /></Protegida>} />
        <Route path="/tipos" element={<Protegida><Tipos /></Protegida>} />
        <Route path="/usuarios" element={<Protegida><Usuarios /></Protegida>} />
        <Route path="/perfis" element={<Protegida><Perfis /></Protegida>} />
        <Route path="/cidadaos" element={<Protegida><Cidadaos /></Protegida>} />
        <Route path="/configuracoes" element={<Protegida><Configuracoes /></Protegida>} />
        <Route path="/modelos" element={<Protegida><Modelos /></Protegida>} />
        <Route path="/auditoria" element={<Protegida><Auditoria /></Protegida>} />
        <Route path="/contribuinte-presencial" element={<Protegida><ContribuintePresencial /></Protegida>} />
        <Route path="/aprovacoes" element={<Protegida><Aprovacoes /></Protegida>} />
        <Route path="/meu-perfil" element={<Protegida><MeuPerfil /></Protegida>} />
        <Route path="/protocolo" element={<ProtocoloPublico />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
